import React from 'react';
import { SportIconNui } from 'nike-ui/src/icons/SportIconNui';

export default function withSportHeader(sportId, sportDisplayName, content) {
    return (
        <div className="today-offer" key={sportId}>
            <div className="today-items">
                <div className={`today-header bg-${sportId} flex items-center py-10`}>
                    <div className="today-icon-box">
                        <SportIconNui
                            sportId={sportId}
                            sizeX={'22'}
                            sizeY={'22'}
                            className={'c-white'}
                            dataAtid={'sport-icon'}
                        />
                    </div>
                    <div className="today-label">{sportDisplayName}</div>
                </div>
                {content}
            </div>
        </div>
    );
}
